import React from 'react';
import PropTypes from 'prop-types';
import useWindowWidth from '../../hooks/useWindowWidth';

import styles from './article_card.module.scss';

const ArticleCard = ({ title, date, image, content }) => {
  const width = useWindowWidth();

  return (
    <div className={width > 600 ? styles.card : styles.cardphone}>
      <div className={styles.header}>
        <h4>{title}</h4>
        <h5>{date}</h5>
      </div>
      <div className={styles.body}>
        <div className={styles.imgcontainer}>
          <img src={image} alt={title} />
        </div>
        <div className={width > 1024 ? styles.textcontainer : styles.textcontainertab}>
          <p>{content}</p>
        </div>
      </div>
    </div>
  );
};

ArticleCard.propTypes = {
  title: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};

export default ArticleCard;
